import React from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  FormErrorMessage,
  FormHelperText,
} from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';

export interface SearchInputProps {
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helperText?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const SearchInput: React.FC<SearchInputProps> = ({
  label,
  placeholder = 'Search...',
  value,
  onChange,
  error,
  helperText,
  isRequired = false,
  isDisabled = false,
  size = 'md',
}) => {
  return (
    <FormControl
      isRequired={isRequired}
      isInvalid={!!error}
      isDisabled={isDisabled}
    >
      {label && (
        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
          {label}
        </FormLabel>
      )}
      <InputGroup size={size}>
        <InputLeftElement pointerEvents="none">
          <FiSearch color="gray.400" />
        </InputLeftElement>
        <Input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          bg="white"
          borderColor="gray.300"
          _hover={{ borderColor: 'gray.400' }}
          _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px blue.500' }}
          pl={10}
        />
      </InputGroup>
      {error && <FormErrorMessage fontSize="sm">{error}</FormErrorMessage>}
      {helperText && !error && (
        <FormHelperText fontSize="sm" color="gray.600">
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
